// extracted by mini-css-extract-plugin
export default {"container":"NoItems_container__kPND9","message":"NoItems_message__8AeBf"};